import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsComponent } from './options.component';
// import { TAPOptionsComponent } from './options.tap.component';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';
import { DirectivesModule } from 'src/app/directives/directives.module';

/* REPLICATED FILES */
import { INDRAOptionsComponent } from './options.indra.component';

@NgModule({
	imports: [ CommonModule, SVGModule, IBEAdminModule, DirectivesModule ],
	declarations: [ OptionsComponent, INDRAOptionsComponent ],
	exports: [ DirectivesModule, INDRAOptionsComponent ]
})
export class BookingOptionsModule { }
